module.exports = __webpack_public_path__ + "img/home_spider_1.ca538a69.jpg";